















































































































































































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import { finalize } from 'rxjs/operators'
import { debounce } from 'lodash'
import { translate } from '@/utils/filters'
import $Api from '@api'
import {
    RepaymentPageRecord,
    PartRepaymentData,
    LoanRepaymentRequest,
    CalculationToFactTimeParams,
    VietRepaymentRequest
} from '@/api/model/repayment'
import * as JMath from '@/utils/math'
import store from '@/store'

enum RepaymentType {
    PARTIAL,
    OTHERS
}

// 时间状态：0.当前系统时间小于等于还款计划应还时间（日）;1.当前时间大于还款计划应还时间（日）
enum TimeStatus {
    BEFORE,
    AFTER
}

enum ShouldReduce {
    NO,
    YES
}

@Component
export default class SpecialVietComponent extends Vue {
    @Prop() visible!: boolean
    record!: RepaymentPageRecord
    showSubmitBtn = false
    calcLoading = false
    calculateData: any = []
    unpaidData: PartRepaymentData[] = []
    defaultCalculateData = {
        paidAmount: 0,
        capitalAmount: 0,
        interestAmount: 0,
        penaltyAmount: 0,
        unpaidAmount: 0
    }
    RepaymentType = RepaymentType
    ShouldReduce = ShouldReduce
    shouldReduce = -1
    TimeStatus = TimeStatus
    timeStatus = TimeStatus.BEFORE
    unpaidAmount = 0
    // 保存上次试算输入的值
    cacheInputValue: any = {}
    factTime: any = ''
    remark = ''

    options = {
        disabledDate: function name(time: any) {
            return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
        }
    }

    @Emit('close')
    handleClose(): void {
        // 重置
        this.factTime = ''
        this.remark = store.getters.userName
        this.showSubmitBtn = false
        this.shouldReduce = -1
        this.calculateData = []
        this.cacheInputValue = {}
    }

    @Emit('refresh')
    handleRefresh(): void {}

    @Watch('shouldReduce')
    onRadioChange(val: number) {
        // 重置
        this.factTime = ''
        this.remark = store.getters.userName
        this.calculateData = [{ ...this.defaultCalculateData }]
        this.handleCalculateData()
        //
        if (val > -1) {
            this.showSubmitBtn = true
        }

        if (val === ShouldReduce.NO) {
            this.factTime = new Date().getTime()
        }
    }

    created() {
        this.remark = store.getters.userName
    }

    onDateTimeChange(value: Date): void {
        const { lid, rid, tenantId, indexs, ..._ } = this.record
        const factTime = new Date(this.factTime).getTime()
        this.queryCalculation({ lid, rid, tenantId, indexs, factTime })
    }

    validateForm(): boolean {
        if (!this.factTime) {
            this.$message.error(translate('repayment.unpaid.specialviet.form.factTime.required'))
            return false
        }
        return true
    }

    onSubmit(type: RepaymentType): void {
        if (this.timeStatus === TimeStatus.BEFORE || this.shouldReduce === ShouldReduce.YES) {
            const valid = this.validateForm()
            if (!valid) {
                return
            }
        }

        const { remark } = this
        const { lid, indexs } = this.record
        const [{ paidAmount, capitalAmount, interestAmount, penaltyAmount, ..._ }] = this.calculateData
        const factTime = new Date(this.factTime).getTime()
        const penaltyOverdueAmount = penaltyAmount
        const interestFeeAmount = interestAmount
        const repaymentAction = type
        const subtractFineStatus = this.shouldReduce
        const userId = this.$store.state.auth.authInfo.userId
        const params: VietRepaymentRequest = {
            capitalAmount,
            factTime,
            indexs,
            interestFeeAmount,
            lid,
            paidAmount,
            penaltyOverdueAmount,
            remark,
            repaymentAction,
            subtractFineStatus,
            userId
        }

        MessageBox.confirm(
            translate('repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm', { inputAmount: paidAmount }),
            translate('common.tip'),
            {
                confirmButtonText: translate('common.btn.confirm'),
                cancelButtonText: translate('common.btn.cancel')
            }
        )
            .then(() => {
                $Api.repaymentService.vietRepayment(params).subscribe(
                    data => {
                        Message.success(translate('repayment.unpaid.manualDialog.onPartialPaidSubmit.success') as string)
                        this.handleClose()
                        this.handleRefresh()
                    },
                    error => {
                        Message.error(error.message)
                    }
                )
            })
            .catch(() => {})
    }

    queryCalculation(params: CalculationToFactTimeParams): void {
        this.calcLoading = true
        $Api.repaymentService
            .calculationToFactTime(params)
            .pipe(
                finalize(() => {
                    this.calcLoading = false
                })
            )
            .subscribe(
                data => {
                    const { paidAmount, ..._ } = data
                    if (!this.calculateData.length) {
                        this.calculateData = [{}]
                    }
                    const [calculateItem] = this.calculateData
                    calculateItem.paidAmount = data.unpaidAmount
                    this.calculateData = [{ ...calculateItem, ..._ }]
                    this.handleCalculateData(true)
                },
                error => {
                    Message.error(error.message)
                    this.calculateData = []
                }
            )
    }

    fetchData(record: RepaymentPageRecord): void {
        this.record = record
        const { lid, indexs, ..._ } = record
        $Api.repaymentService.partRepaymentLoadData({ lid, indexs }).subscribe(data => {
            data.interestAmount = this.sum(data.interestAmount, data.feesAmount)
            this.unpaidData = [data]
            this.timeStatus = data.timeStatus
            this.unpaidAmount = data.unpaidAmount
            this.handleCalculateData()
        })

        if (this.timeStatus === TimeStatus.BEFORE) {
            this.factTime = new Date().getTime()
        }
    }

    trialCalculate() {
        const { lid, indexs } = this.record
        const [calculateItem] = this.calculateData
        const { paidAmount } = calculateItem
        this.calcLoading = true

        $Api.repaymentService
            .calcPartRepayment({
                lid,
                indexs,
                paidAmount
            })
            .pipe(
                finalize(() => {
                    this.calcLoading = false
                })
            )
            .subscribe(
                data => {
                    const [calculateItem] = this.calculateData
                    this.calculateData = [{ ...calculateItem, ...data }]
                    this.handleCalculateData(true)
                },
                error => {
                    Message.error(error.message)
                }
            )
    }

    handleCalculateData(isTrial?: boolean) {
        if (this.calculateData.length === 0) {
            this.calculateData = [{ ...this.defaultCalculateData }]
        }
        const [calculateItem] = this.calculateData
        const [unpaidItem] = this.unpaidData

        // 计算利息
        if (calculateItem.feesAmount === undefined) {
            calculateItem.feesAmount = 0
        }
        if (isTrial) {
            const interset = this.sum(calculateItem.interestAmount, calculateItem.feesAmount)
            calculateItem.interestAmount = this.fixedTwo(interset)
        }
        // 计算本次还款金额
        const { capitalAmount, interestAmount, penaltyAmount, feesAmount } = calculateItem
        const total = this.sum(capitalAmount, interestAmount, penaltyAmount)
        calculateItem.paidAmount = this.fixedTwo(total)
        // 计算剩余未还金额
        let unpaidAmount = +JMath.floatSub(unpaidItem.unpaidAmount, calculateItem.paidAmount)
        unpaidAmount = this.fixedTwo(+unpaidAmount)
        calculateItem.unpaidAmount = +unpaidAmount > 0 ? unpaidAmount : 0
    }

    setCalculateInputValue(name: string, value: any) {
        value = value + ''
        const [calculateItem] = this.calculateData
        let [leftVal, rightVal] = value.split('.')

        if (leftVal.length > 1) {
            while (leftVal.startsWith('0')) {
                leftVal = leftVal.slice(1)
            }
        }

        value = leftVal + (rightVal ? '.' + rightVal : '')
        calculateItem[name] = +value
        setTimeout(() => {
            this.cacheInputValue[name] = +value
        }, 0)
    }

    onInputHandler = debounce(({ target }: any, shouldTrial: boolean) => {
        // Keep two decimal places by RegExp
        target.value = target.value.match(/^\d*(\.?\d{0,2})/g)[0] || null

        this.setCalculateInputValue(target.name, target.value)

        if (shouldTrial) {
            if (this.cacheInputValue.paidAmount !== +target.value || +target.value === 0) {
                this.trialCalculate()
            }
        } else {
            this.handleCalculateData()
        }
    }, 1 * 1000)

    sum(...args) {
        return args.reduce((acc, cur) => {
            acc += +cur
            return acc
        }, 0)
    }

    fixedTwo = (num: number): number => {
        let val = JMath.floatMul(num, 100)
        val = JMath.floatDiv(val, 100)
        return val
    }
}
